<template>
  <div class="posterBox">
    <canvas id="myCanvas" width="750" height="1333" style="display:none;"></canvas>
    <div class="show_shareImg" v-if="show_shareImgbox" v-cloak>
      <img :src="lastShareBG" alt="">
      <div class="cancelRuleBox2" @click="closeshareImgbox"></div>
    </div>
  </div>
</template>

<script>
import {base64pic} from "@/config/preloadFile";

export default {
  name: "setPoster.vue",
  data(){
    return{
      show_shareImgbox:false,
      lastShareBG:''
    }
  },
  mounted() {
      this.init()
  },
  methods:{
    closeshareImgbox(){
      this.$router.go(-1);
    },
    async init(){
      let _this = this;
      let newimg = new Image()
      newimg.src = require('../../public/guangming_milk/poster/poster5.jpg');
      newimg.crossOrigin = "";
      newimg.onload = async function() {
        let canvas1 = document.getElementById('myCanvas'); // 新建canvas
        let context1 = canvas1.getContext('2d');
        canvas1.width = 750;
        canvas1.height = 1333;
        context1.drawImage(newimg, 0, 0, 750, 1333);
        //画背景图
        // this.$config.getCookie('headimgurl')
        // let nickName = '323232';
        // let baseheader = await _this.$config.getBase64('https://thirdwx.qlogo.cn/mmopen/vi_32/NGib8v9Lml2LzjmXBntdd1vpNYTianQnjBdTQZk2iadyG1gu0gplL7UaO8e9gZkibzp111S8sYJyqm7hq0fDygKSZQ/132')
        let baseheader = await _this.$config.getBase64(_this.$config.getCookie('headimgurl'))
        let nickName = _this.$config.getCookie('nickname');


        let codeimg = new Image();
        codeimg.src=require('../../public/guangming_milk/share_logo.png');
        codeimg.crossOrigin = '';
        codeimg.onload = async function() {
          let canvas1 = document.getElementById('myCanvas'); // 新建canvas
          let context1 = canvas1.getContext('2d');
          context1.drawImage(codeimg, 320, 1080, 140, 140);


          // 画头像

          let imageHeader = new Image()
          imageHeader.src = baseheader;
          imageHeader.crossOrigin = "Anonymous";
          imageHeader.onload = function (){
            let canvas1 = document.getElementById('myCanvas'); // 新建canvas
            let context1 = canvas1.getContext('2d');

            // context1.drawImage(imageHeader, 110, 184, 73, 73);
            context1.drawImage(imageHeader, 203, 430, 100, 100);
            context1.fillStyle="#59474d"
            context1.font="52px Arial";
            context1.fillText(nickName,317,480);//220

            let data1 = canvas1.toDataURL('image/jpeg')
            _this.lastShareBG = data1;

            // console.log(data1, '这是我们要生成的最终图片')
            // 这个的base就是最终的那张图
            _this.show_shareImgbox = true;
            console.log(_this.show_shareImgbox, '_this.show_shareImgbox')
          }
        }

      }
    }
  }
}
</script>

<style scoped>
.posterBox{
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #ffdfcf;
}


.show_shareImg{
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  /*bottom: 0;*/
  z-index: 1000;
  overflow-y: hidden;
}
.show_shareImg img{
  width: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  z-index: 1001;

}
.cancelRuleBox2 {
  width: 5.4vw;
  height: 5.4vw;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 65vw;
  margin-left: -2.7vw;
  background: url('https://frontend.originoo.com/ty/huanghai/icon_cancel.png')no-repeat;
  background-size: 100% 100%;
  z-index: 1001;
}


</style>
